import axios from 'axios';

export function paymentErrorMessage(
  err: unknown,
  fallback = 'Please retry or check your balance',
): string {
  if (axios.isAxiosError(err)) return fallback;
  return err instanceof Error ? err.message : fallback;
}
